import { useNavigate } from 'react-router-dom';
import { BookOpenCheck, Phone, AlertTriangle } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';

export default function SafetyScreen() {
  const navigate = useNavigate();

  const resources = [
    {
      icon: <BookOpenCheck className="w-5 h-5 text-blue-600" />,
      title: 'Stay Safe on NGL',
      desc: 'Tips to protect yourself and keep your link positive.',
      button: { text: 'Read Tips', onClick: () => alert('Opening safety tips...') },
    },
    {
      icon: <AlertTriangle className="w-5 h-5 text-yellow-600" />,
      title: 'Report Abuse',
      desc: 'If you receive harmful or dangerous messages, report them here.',
      button: { text: 'Report', onClick: () => alert('Redirecting to report...') },
    },
    {
      icon: <Phone className="w-5 h-5 text-red-500" />,
      title: 'Support Helplines',
      desc: 'Find emotional support contacts in your country.',
      button: { text: 'Contact Support', onClick: () => alert('Opening helpline info...') },
    },
  ];

  return (
    <div className="flex justify-center bg-[#f5f5f5] overflow-hidden no-scrollbar pt-10 h-screen px-4 py-6 text-black font-[SF Pro Display]">
      <div className="w-full max-w-sm">
        {/* Header */}
        <CustomAppBar
          title="Safety Resources"
        />

        {/* Resource Cards */}
        <div className="space-y-4 mt-5">
          {resources.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-4 shadow-md flex flex-col space-y-4"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-gray-100 rounded-full p-2">
                  {item.icon}
                </div>
                <div>
                  <p className="font-semibold text-[15px]">{item.title}</p>
                  <p className="text-sm text-gray-600">{item.desc}</p>
                </div>
              </div>
              <button
                onClick={item.button.onClick}
                className="self-start bg-black text-white text-sm font-semibold px-4 py-1.5 rounded-full hover:bg-gray-900 transition"
              >
                {item.button.text}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

